// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"pdfs_scrollbar__20Aa1"};